import { EMPTY_STRING } from '../../../../constants/common'
import { InputField } from '../../../Input'
import { Control } from '../Control'

export function ControlText({ value, onChange, ...controlProps }) {
  function handleInputChange(event) {
    onChange(value, { value: event.target.value })
  }

  return (
    <Control {...controlProps} value={value} onChange={onChange}>
      <InputField
        borderless
        disabled={value.omitted}
        value={value.value ?? EMPTY_STRING}
        onChange={handleInputChange}
      />
    </Control>
  )
}

export default ControlText
